<!-- This crew card is for the crew creation page, it has deliable employees/equipment, a date range,
and has drag and drop cabilities for employees/equipment.
Basically, this card is used to create/edit crews.
WARNING: If you make a change to this card, check the other crew card to see if it needs the change as well.
-->

<p-card class="crew-card" [ngClass]="{'crew-invalid': crewErrors.length > 0 }">
  <p-header>
    {{crewTitle}}

    @if (crewErrors.length > 0) {
    <div style="float: right;">
      <i class="pi pi-exclamation-triangle" (mouseenter)="errorPanel.toggle($event)"
        (mouseleave)="errorPanel.toggle($event)" (click)="errorPanel.toggle($event)"></i>
      <p-popover #errorPanel>
        @for (error of crewErrors; track error) {
        <div>
          {{error}}
        </div>
        }
      </p-popover>
    </div>
    }
  </p-header>
  <div style="text-align: left;">{{employeeList}}</div>


  <div class="p-grid">
    <div class="p-col">
      <p-datepicker [maxDate]="crew.endDate" [(ngModel)]="crew.startDate" class="secondary" (ngModelChange)="save()"
        [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" appendTo="body"></p-datepicker>
    </div>
    <div class="p-col-1 center">
      to
    </div>
    <div class="p-col">
      <p-datepicker [minDate]="crew.startDate" [(ngModel)]="crew.endDate" class="secondary" (ngModelChange)="save()"
        [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" appendTo="body"></p-datepicker>
    </div>
  </div>

  <div class="toggle-crew-information">
    @if (isCollapsed) {
    <div>
      <span (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" class="plus-minus-span">
        +
      </span>
    </div>
    }
    @if (!isCollapsed) {
    <div>
      <span (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" class="plus-minus-span">
        -
      </span>
    </div>
    }
    <div [ngbCollapse]="isCollapsed" class="crew-information">
      <div [id]="'crewEquipmentList-' + crew.id" [cdkDropListData]="crew.crewEquipment"
        [cdkDropListConnectedTo]="dragAndDropService.allCrewEquipmentLists" cdkDropList
        (cdkDropListDropped)="drop($event)">
        @if (crew.crewEquipment) {
        <span>Equipment</span>
        }
        @for (crewEquip of crew.crewEquipment; track crewEquip) {
        <div class="inner-card" cdkDrag (cdkDragStarted)="dragStart($event)">
          <app-equipment-card [equipment]="crewEquip.equipment" [deleteable]="true"
            (deleted)="deleteEquipmentFromCrew($event)"></app-equipment-card>
        </div>
        }
        @if (crew.crewEquipment.length == 0) {
        <div class="inner-card drag-placeholder">
          <p-card>Drag Equipment Here</p-card>
        </div>
        }
      </div>
      <div [id]="'crewEmployeeList-' + crew.id" [cdkDropListData]="crew.crewEmployees"
        [cdkDropListConnectedTo]="dragAndDropService.allCrewEmployeeLists" cdkDropList
        (cdkDropListDropped)="drop($event)">
        @if (crew.crewEmployees) {
        <span>Employees</span>
        }
        @for (crewEmployee of crew.crewEmployees; track crewEmployee) {
        <div class="inner-card" (cdkDragStarted)="dragStart($event)" cdkDrag>
          <app-employee-card [employee]="crewEmployee.employee" [deleteable]="true"
            (deleted)="deleteEmployeeFromCrew($event)"></app-employee-card>
        </div>
        }
        @if (crew.crewEmployees.length == 0) {
        <div class="inner-card drag-placeholder">
          <p-card>Drag Person Here</p-card>
        </div>
        }
      </div>
    </div>
  </div>
  <p-footer>
    <p-button type="button" label="Delete Crew" severity="danger" class="deleteButton" (click)="delete()"></p-button>
  </p-footer>
</p-card>